export default __webpack_public_path__ + "static/media/auto-renewal-icon.dd58330a.svg";